import React, { useState } from 'react';
import TextField from '@mui/material/TextField';
import SearchIcon from '@mui/icons-material/Search';
import InputAdornment from '@mui/material/InputAdornment';
import IconButton from '@mui/material/IconButton';

const SearchComponent = ({handleFilter}) => {
    const [searchTerm, setSearchTerm] = useState("");

    const callHandleFilter = (searchSt) => {
        setSearchTerm(searchSt)
        handleFilter(searchSt);
    }
  return (
    <TextField
      label="Filter Todos"
      variant="outlined"
      fullWidth
      size="small"
      value={searchTerm}
      onChange={(e) => {callHandleFilter(e.target.value)}}
      InputProps={{
        endAdornment: (
          <InputAdornment position="end">
            <IconButton size="small">
              <SearchIcon />
            </IconButton>
          </InputAdornment>
        ),
      }}
    />
  );
};

export default SearchComponent;
